import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ManureSpaceState } from '../models/manure-space.models';

export const selectManureSpaceState = createFeatureSelector<ManureSpaceState>('manureSpace');

export const selectManureSpaceDetailsResource = createSelector(
  selectManureSpaceState,
  (state) => state?.manureSpace,
);

export const selectManureSpaceFilteredByManureCodeResource = createSelector(
  selectManureSpaceState,
  (state) => state?.manureSpaceFilteredByManureCode,
);
export const selectManureSpaceDetails = createSelector(
  selectManureSpaceDetailsResource,
  (resource) => (resource.state == 'loaded' ? (resource?.data ?? null) : null),
);

export const selectManureSpaceFilteredByManureCode = createSelector(
  selectManureSpaceFilteredByManureCodeResource,
  (resource) => (resource.state == 'loaded' ? (resource?.data ?? null) : null),
);

export const hasManureSpaceDetails = createSelector(
  selectManureSpaceDetails,
  (manureSpace) => !!manureSpace,
);

export const hasNoManureSpaceDetails = createSelector(
  selectManureSpaceDetailsResource,
  (resource): boolean => !(resource?.state === 'loaded' && !!resource?.data),
);

export const selectManureSpaceDetailsByManureCodeId = createSelector(
  selectManureSpaceFilteredByManureCode,
  (manureSpace) => manureSpace?.id ?? null,
);

export const selectManureSpaceDetailsFertilizers = createSelector(
  selectManureSpaceDetails,
  (manureSpace) => manureSpace?.fertilizers ?? [],
);

export const selectManureSpaceDetailsHasCropFields = createSelector(
  selectManureSpaceDetails,
  (manureSpace) => !!manureSpace?.cropFieldIds?.length,
);

export const selectFertilizersFromDeliveryResource = createSelector(
  selectManureSpaceState,
  (state) => state?.fertilizersFromDelivery ?? null,
);

export const selectManureSpaceByPeriodResource = createSelector(
  selectManureSpaceState,
  (state) => state?.manureSpaceByPeriod,
);

export const hasManureSpaceByPeriod = createSelector(
  selectManureSpaceByPeriodResource,
  (resource): boolean => resource?.state === 'loaded' && !!resource?.data,
);

export const hasNoManureSpaceByPeriod = createSelector(
  selectManureSpaceByPeriodResource,
  (resource): boolean => !(resource?.state === 'loaded' && !!resource?.data),
);

export const selectActiveTabIndex = createSelector(
  selectManureSpaceState,
  (state) => state?.activeTabIndex,
);

export const selectActiveTabManureSpace = createSelector(selectManureSpaceState, (state) => {
  if (state?.activeTabIndex == 0) {
    return state?.manureSpaceFilteredByManureCode;
  }
  if (state?.activeTabIndex == 1) {
    return state?.manureSpaceByPeriod;
  }
  if (state?.activeTabIndex == 2) {
    return state?.manureSpace;
  }
});

export const selectManureSpaceDetailsByPeriodId = createSelector(
  selectManureSpaceByPeriodResource,
  (resource) => (resource.state == 'loaded' ? (resource?.data?.id ?? null) : null),
);

export const selectManureSpaceDetailsId = createSelector(
  selectActiveTabManureSpace,
  (manureSpace) => (manureSpace?.state === 'loaded' ? manureSpace.data?.id : null) ?? null,
);

export const selectManureSpaceComment = createSelector(
  selectActiveTabManureSpace,
  (manureSpace) => (manureSpace?.state === 'loaded' ? manureSpace.data?.comment : '') ?? '',
);

export const selectInitialStockMatchesRvo = createSelector(
  selectActiveTabManureSpace,
  (manureSpace) =>
    (manureSpace?.state === 'loaded' ? manureSpace.data?.initialStockMatchesRvo : false) ?? false,
);
